var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getItemTableContainerClass},[_c('ItemTable',_vm._b({ref:"itemTable",attrs:{"data-test-id":"commandRunnerItemTable"}},'ItemTable',_vm.itemTableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }